export default __webpack_public_path__ + "static/media/undraw_warning_cyit.e7726e9a.svg";